import React, { Component } from 'react'

class SurveySettingHome extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }
  changed (name, e) {
    this.setState({[name]: e.target.value})
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'surveySetting':
        this.props.history.push('/admin/survey_setting')
        break
      case 'surveyQuestion':
        this.props.history.push('/admin/survey_bigquestion')
        break
      default:
        break
    }
  }
  render () {
    const showSurveyQuestionButton = true
    return (
      <div>
        <section className='nav nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>アンケート<br />
                    <small>こちらからアンケート設定を開始できます。</small>
                  </h3>
                </header>
              </div>
              <div className='page-nav-options'>
                <div className='span9' />
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <div className='box'>
            <div className='box-header'>
              <i className='icon-file' />
              <h5>アンケート</h5>
            </div>
            <div className='box-content'>
              <p>こちらでは、以下の作業を開始できます。</p>
              <table className='hidden-phone'>
                <tbody>
                  <tr>
                    <th><button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('surveySetting')}><i className='icon-file' />アンケート設定</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-cushion-menu-msg'>こちらでアンケートの設定ができます。</div></td>
                  </tr>
                  {showSurveyQuestionButton && (
                  <tr>
                    <th><button className='btn kw-cushion-menu-btn' onClick={(e) => this.onPageMenuClicked('surveyQuestion')}><i className='icon-comment' />アンケート設問設定</button></th>
                    <td>　・・・　</td>
                    <td><div className='kw-cushion-menu-msg'>こちらでアンケートの設問を設定ができます。</div></td>
                  </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default SurveySettingHome



// WEBPACK FOOTER //
// ./src/admin/pages/secure/SurveySettingHome.js